'use client';

import dynamic from 'next/dynamic';
import useIsPrintModalEnabled from '@alltrails/experiments/hooks/useIsPrintModalEnabled';
import type TrailDetails from '@alltrails/types/TrailDetails';
import { useAppSelector } from '@/utils/redux';

const TrailPrintModal = dynamic(() => import('./TrailPrintModal'), { ssr: false });

type TrailPrintEntryProps = {
  trailDetails: TrailDetails;
};

const TrailPrintEntry = ({ trailDetails }: TrailPrintEntryProps) => {
  const isPrintModalEnabled = useIsPrintModalEnabled();
  const { isPrintRequested, isTrailMapOpen } = useAppSelector(state => ({
    isPrintRequested: state.trailPage.isPrintRequested,
    isTrailMapOpen: state.trailPage.isTrailMapOpen
  }));

  return isPrintModalEnabled && isPrintRequested && !isTrailMapOpen ? <TrailPrintModal trailDetails={trailDetails} /> : null;
};

export default TrailPrintEntry;
